import React from 'react'
import Header from '@/components/mfe/Header'
import Footer from '@/components/mfe/Footer'
import { Locale } from '../../locale'
import getConfig from 'next/config'

export type KoodoGlobalElementsProps = {
  children: React.ReactNode
  locale: Locale
}

export function KoodoGlobalElements({ children, locale }: KoodoGlobalElementsProps) {
  const { IS_PROD, IS_PREVIEW } = getConfig()?.publicRuntimeConfig
  // This probably won't work on client side
  let environment
  if (IS_PROD) {
    environment = 'production'
  } else if (IS_PREVIEW) {
    environment = 'preview'
  } else {
    environment = 'staging'
  }

  return (
    <div className="app-container">
      <Header
        type="commerce"
        locale={{ lang: locale.language.toLowerCase() as 'en' | 'fr', prov: locale.province?.toLowerCase() as any }}
        environment={environment}
        cartHasItem={false}
        enabledAccountSelector={false}
        enabledCommerceOfferStar={false}
      />

      <main>{children}</main>

      <Footer
        locale={{ lang: locale.language.toLowerCase() as 'en' | 'fr', prov: locale.province?.toLowerCase() as any }}
        environment={environment}
      />
    </div>
  )
}
